module.exports = __webpack_public_path__ + "static/media/KohinoorBangla-Bold.98952e7f.svg";